import { createTheme, responsiveFontSizes } from "@mui/material/styles";

import palette from "./palette";

const theme = responsiveFontSizes(
  createTheme({
    palette,
    layout: {
      contentWidth: 1650,
    },
    typography: {
      //   fontFamily: "lato",
    },
    zIndex: {
      appBar: 1200,
      drawer: 1100,
    },
    overrides: {
      MuiButton: {
        containedSecondary: {
          color: "white",
        },
      },
    },
  })
);

export default theme;
